export default function DonutChart({data, size=90, stroke=14, descripcion="Gráfico circular"}) {
  const r = (size - stroke) / 2;
  const circ = 2 * Math.PI * r;
  const total = data.reduce((s,d)=>s+d.value,0)||1;
  let offset = 0;
  return (
    <svg width={size} height={size} role="img" aria-label={descripcion} style={{transform:"rotate(-90deg)",flexShrink:0}}>
      {data.map((d,i)=>{
        const dash = (d.value/total)*circ;
        const seg = <circle key={i} r={r} cx={size/2} cy={size/2} fill="none"
          stroke={d.color} strokeWidth={stroke} strokeDasharray={`${dash} ${circ-dash}`}
          strokeDashoffset={-offset} strokeLinecap="butt"/>;
        offset += dash;
        return seg;
      })}
      {data.every(d=>d.value===0)&&<circle r={r} cx={size/2} cy={size/2} fill="none" stroke="var(--bg)" strokeWidth={stroke}/>}
    </svg>
  );
}
